import React from 'react';
interface PersonalizeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOptionSelect: (option: string) => void;
}
export const PersonalizeModal = ({
  isOpen,
  onClose,
  onOptionSelect
}: PersonalizeModalProps) => {
  if (!isOpen) return null;
  const options = ["It's my life", "Oh, I'm serious", 'I like to catch some games occasionally', 'I want to hang out and watch with my friends', "I'm up for whatever's fun"];
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-118">
      <div className="bg-[#22252A] rounded-xl max-w-md w-full shadow-lg border border-gray-700" data-id="element-119">
        <div className="p-6" data-id="element-120">
          <h2 className="text-xl font-bold text-[#F5F5F7] mb-6" data-id="element-121">
            To start, help me understand how serious an NBA fan you are?
          </h2>
          <div className="space-y-3" data-id="element-122">
            {options.map(option => <button key={option} onClick={() => onOptionSelect(option)} className="w-full text-left px-4 py-3 bg-[#2C2F33] hover:bg-[#3A3D42] text-[#F5F5F7] rounded-lg transition-colors" data-id="element-123">
                {option}
              </button>)}
          </div>
          <button onClick={onClose} className="mt-6 w-full border border-gray-600 text-gray-400 px-4 py-2 rounded-lg hover:bg-[#2C2F33] transition-colors" data-id="element-124">
            Cancel
          </button>
        </div>
      </div>
    </div>;
};